import React from 'react'
import { CButton, CModal, CModalBody, CModalHeader, CModalTitle, CModalFooter } from '@coreui/react';
import { DatePicker, Flex, Input, Select, Typography } from 'antd';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { MaskedInput } from 'antd-mask-input';
import { bookingAction } from 'src/store/Slices/Administrator/BookingSlice';
import { getClubs, getTrainers, getUsers } from 'src/store/Slices/DropDownSlice';
import { getUserInfo } from 'src/store/Slices/ClientsSlice';
import { getServices } from 'src/store/Slices/AbonementsSlice';

const AddEditBookingModal = ({ visible, setVisible, bookingInfo }) => {

    const dispatch = useDispatch()

    const users = useSelector(state => state.DropDownSlice.users)
    const usersLoading = useSelector(state => state.DropDownSlice.usersLoading)
    const trainersList = useSelector(state => state.DropDownSlice.trainersList)
    const clubs = useSelector(state => state.DropDownSlice.clubs)
    const abonementServices = useSelector(state => state.AbonementsSlice.abonementServices)

    const [userId, setUserId] = useState()
    const [name, setName] = useState()
    const [phone, setPhone] = useState()
    const [date, setDate] = useState()
    const [trainer, setTrainer] = useState()
    const [club, setClub] = useState()
    const [service, setService] = useState()

    useEffect(() => {
        setName()
        setPhone()
        setDate()
        setTrainer()
        setClub()
        setService()
        setUserId()
    }, [visible.flag])


    useEffect(() => {
        if (visible.flag === 'edit') {
            setName(bookingInfo?.clientFio)
            setPhone(bookingInfo?.phone)
        }
    }, [visible, bookingInfo])

    const onClickSubmit = () => {
        dispatch(bookingAction({
            flag: visible.flag === 'add' ? 'put' : 'post', value: {
                id: visible.flag !== 'add' ? bookingInfo.id : undefined,
                employId : trainer,
                serviceId: service,
                dateTime : date,
                userId: userId,
            }
        })).then(() => {
            dispatch(bookingAction({ flag: 'get' })).then(() => {
                setVisible({ open: false, flag: '' })
            })
        })
    }


    return (
        <CModal
            alignment="center"
            visible={visible.open}
            aria-labelledby="VerticallyCenteredExample"
            onClose={() => { setVisible({ open: false, flag: '' }) }}
            keyboard={true}
        >
            <CModalHeader>
                <CModalTitle id="VerticallyCenteredExample">{
                    visible.flag === 'add' ? 'Добавить бронирование' : 'Редактировать бронирование'
                }</CModalTitle>
            </CModalHeader>
            <CModalBody style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>

                <Flex vertical gap={16} style={{ marginTop: '20px' }}>
                    <>
                        <div>
                            <Typography.Title level={5}>ФИО</Typography.Title>
                            <Select
                                filterSort={false}
                                filterOption={false}
                                loading={usersLoading}
                                showSearch
                                onSearch={(value) => { dispatch(getUsers({ search: value })) }}
                                onClick={() => { dispatch(getUsers()) }}
                                placeholder='Выбрать'
                                style={{ width: '100%' }}
                                value={name}
                                options={users?.data?.value}
                                onChange={(e, b) => {
                                    setUserId(e);
                                    setName(b?.label)
                                }}
                                onSelect={(id) => {
                                    dispatch(getUserInfo({ id: id })).then((res) => {
                                        if (res?.payload?.data?.isSuccess) {
                                            setPhone(res?.payload?.data?.value?.phoneNumber)
                                        }
                                    })
                                }}
                            />
                        </div>

                        <div>
                            <Typography.Title level={5}>Телефон</Typography.Title>
                            <Input
                                disabled
                                value={phone}
                                onChange={e => setPhone(e.currentTarget.value)}
                            />
                        </div>

                        <div>
                            <Typography.Title level={5}>Дата</Typography.Title>
                            <DatePicker
                                style={{ width: '100%' }}
                                value={date}
                                onChange={e => setDate(e)}
                                showTime
                            />
                        </div>

                        <div>
                            <Typography.Title level={5}>Тренер</Typography.Title>
                            <Select
                                onClick={() => { dispatch(getTrainers()) }}
                                style={{ width: '100%' }}
                                options={trainersList?.data?.value}
                                onChange={e => setTrainer(e)}
                                value={trainer}
                                placeholder='Выбрать'
                                onSelect={(e, b) => {
                                    dispatch(getClubs()).then(() => {
                                        
                                        setClub(clubs?.data?.value.find(el => el.label === b.clubName)?.value)
                                    })
                                }}
                            />
                        </div>
                        <div>
                            <Typography.Title level={5}>Клуб</Typography.Title>
                            <Select
                                disabled
                                onClick={() => { dispatch(getClubs()) }}
                                style={{ width: '100%' }}
                                options={clubs?.data?.value}
                                onChange={e => setClub(e)}
                                value={club}
                                placeholder='Выбрать'
                            />
                        </div>
                        <div>
                            <Typography.Title level={5}>Услуга</Typography.Title>
                            <Select
                                onClick={() => { dispatch(getServices()) }}
                                style={{ width: '100%' }}
                                options={abonementServices?.data?.value}
                                onChange={e => setService(e)}
                                value={service}
                                placeholder='Выбрать'
                            />
                        </div>
                    </>
                </Flex>

            </CModalBody>
            <CModalFooter>
                <CButton
                    onClick={() => { setVisible({ open: false, flag: '' }) }}
                    className='text-light'
                    color="secondary"
                >
                    Закрыть
                </CButton>
                <CButton onClick={onClickSubmit} className='text-light'>
                    {visible.flag === 'add' ? 'Добавить' : 'Редактировать'}
                </CButton>
            </CModalFooter>
        </CModal>
    )
}

export default AddEditBookingModal